import { CHAIN_RPC_URLS_BIFROST_TESTNET as SDK_CHAIN_RPC_URLS_BIFROST_TESTNET } from '@bifrost-platform/bifront-sdk-react-biholder';

// rpc urls
export const TESTNET_CHAIN_RPC_URLS_BIFROST =
  SDK_CHAIN_RPC_URLS_BIFROST_TESTNET;
export const TESTNET_CHAIN_RPC_URLS_ETHEREUM = [
  'https://rpc.sepolia.org',
  'https://ethereum-sepolia.blockpi.network/v1/rpc/public',
  'https://rpc-sepolia.rockx.com',
  'https://1rpc.io/sepolia',
];
export const TESTNET_CHAIN_RPC_URLS_ARBITRUM = [
  'https://arbitrum-sepolia-rpc.publicnode.com',
  'https://arbitrum-sepolia.therpc.io',
  'https://arbitrum-sepolia.api.onfinality.io/public',
];
export const TESTNET_CHAIN_RPC_URLS_POLYGON = [
  'https://rpc.ankr.com/polygon_mumbai',
  'https://matic-mumbai.chainstacklabs.com',
];
export const TESTNET_CHAIN_RPC_URLS_BSC = [
  'https://data-seed-prebsc-1-s1.binance.org:8545',
  'https://data-seed-prebsc-1-s2.binance.org:8545',
];
export const TESTNET_CHAIN_RPC_URLS_BASE = [
  'https://goerli.base.org',
  'https://1rpc.io/base-goerli',
  'https://base-goerli.public.blastapi.io',
];

export const TESTNET_CHAIN_RPC_URL_BIFROST = TESTNET_CHAIN_RPC_URLS_BIFROST[0];
export const TESTNET_CHAIN_RPC_URL_ETHEREUM =
  TESTNET_CHAIN_RPC_URLS_ETHEREUM[0];
export const TESTNET_CHAIN_RPC_URL_ARBITRUM =
  TESTNET_CHAIN_RPC_URLS_ARBITRUM[0];
export const TESTNET_CHAIN_RPC_URL_POLYGON = TESTNET_CHAIN_RPC_URLS_POLYGON[0];
export const TESTNET_CHAIN_RPC_URL_BSC = TESTNET_CHAIN_RPC_URLS_BSC[0];
export const TESTNET_CHAIN_RPC_URL_BASE = TESTNET_CHAIN_RPC_URLS_BASE[0];

export const TESTNET_CHAIN_RPC_URLS = [
  TESTNET_CHAIN_RPC_URLS_BIFROST,
  TESTNET_CHAIN_RPC_URLS_ETHEREUM,
  TESTNET_CHAIN_RPC_URLS_ARBITRUM,
  TESTNET_CHAIN_RPC_URLS_BSC,
  TESTNET_CHAIN_RPC_URLS_POLYGON,
  TESTNET_CHAIN_RPC_URLS_BASE,
];
